import { Flex } from "@chakra-ui/react";

const TONE_STYLES = {
  success: { bg: "success-subtle", color: "success-text" },
  warning: { bg: "warning-subtle", color: "warning-text" },
  teal: { bg: "teal-subtle", color: "teal-text" },
  danger: { bg: "danger-subtle", color: "danger-text" },
  neutral: { bg: "app-muted", color: "app-muted-fg" },
  brand: { bg: "accent-subtle", color: "accent-text" },
};

export default function IconTile({ icon: Icon, tone = "neutral", size = 44, ...rest }) {
  const style = TONE_STYLES[tone] ?? TONE_STYLES.neutral;
  return (
    <Flex
      align="center"
      justify="center"
      boxSize={`${size}px`}
      borderRadius="lg"
      bg={style.bg}
      color={style.color}
      flexShrink={0}
      {...rest}
    >
      {Icon ? <Icon size={size * 0.45} /> : null}
    </Flex>
  );
}
